import React from 'react';
import { StatusBadge } from '../../components/ui';

interface Detail { email: string; success: boolean; error?: string }

/** Ergebnis eines Laufs (Clay, Lemlist): Summen als Badges, Details als Tabelle. */
export const ErgebnisTabelle: React.FC<{
  titel: string;
  gut: number;
  gutLabel: string;
  schlecht: number;
  details: Detail[];
}> = ({ titel, gut, gutLabel, schlecht, details }) => (
  <section className="card" aria-label={titel}>
    <h3 className="card-title">{titel}</h3>
    <div className="lead-ergebnis__summe">
      <StatusBadge tone="success" icon="check">{gut} {gutLabel}</StatusBadge>
      {schlecht > 0 && <StatusBadge tone="danger">{schlecht} fehlgeschlagen</StatusBadge>}
    </div>
    {details.length > 0 && (
      <div className="table-container">
        <table className="table">
          <thead><tr><th>E-Mail</th><th>Ergebnis</th></tr></thead>
          <tbody>
            {details.map((d, i) => (
              <tr key={`${d.email}-${i}`}>
                <td className="text-sm">{d.email}</td>
                <td>
                  {d.success
                    ? <StatusBadge tone="success">ok</StatusBadge>
                    : <><StatusBadge tone="danger">Fehler</StatusBadge>{d.error && <span className="text-xs text-secondary"> {d.error}</span>}</>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </section>
);
